import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../../SimpleBlockContent'
import Img from '../../../../Img'
import CtaV2 from '../../../../CtaV2'

function LiteFormulaWheelHero({ title, titleCaption, image, cta }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.textWrapper}>
          <div className={styles.captionWrapper}><SimpleBlockContent blocks={titleCaption} noSpace/></div>
          {/* Single-<h1> rule (Audit A #1): this hero title is the page's one
              visible, keyword-rich <h1>. `.h1-contents` adds no box so the design
              is byte-identical. Dedicated hero (max once per page) => unconditional. */}
          <h1 className="h1-contents"><div className={styles.titleOverrideFontSize}><SimpleBlockContent blocks={title} noSpace/></div></h1>
          { cta && <div className="mt-6"><CtaV2 {...cta}/></div> }
        </div>
        {
          image && (
            <div className={styles.imageWrapper}>
              {/* task #67: image is now a ResolvedImage descriptor; hero/LCP -> priority */}
              <Img
                image={image}
                alt={title.text}
                objectFit="contain"
                priority
              />
            </div>
          )
        }
      </div>
    </div>
  )
}

export default LiteFormulaWheelHero
